var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{class:{ noGeo : this.$store.state.infoDay === null },attrs:{"id":"home"}},[_c('HomeSearch'),(!_vm.isReady)?_c('HomeLoader'):_vm._e(),(_vm.isReady && this.infoDay)?_c('HomeResult'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }